<template lang="pug">
  .PedidosValidarSingle
    .box-search
      .container
        .row
          .col-sm-12 &nbsp;

    .container(v-if="messageError")
      .row
        .col-sm-12
          div(class="alert alert-warning" role="alert") {{messageError}}
      .row
        .col-sm-12.text-right
          p
            button.btn.btn-cancel(@click="goBack()") #[translate Volver]
          p &nbsp;
    .container(v-if="messageOk")
      .row
        .col-sm-12
          div(class="alert alert-warning alert-success" role="alert") {{messageOk}}
      .row
        .col-sm-12.text-right
          p
            button.btn.btn-cancel(@click="goBack()") #[translate Volver]
          p &nbsp;

    div(v-if="!messageError && !messageOk && fecha")

      .box-1
        .container
          .row
            .col-sm-12
              router-link( :to="{ name: 'validarPedidos'}" ) #[translate Mis pedidos] > &nbsp;
              span #[translate Pedido] {{number}}

      .container.table-1
        .row.table-head
          .holder-cn
            h3 #[translate Cliente]
          .holder-cn
            h3  #[translate Centro de envío]
          .holder-cn
            h3
              span #[translate Pedido nº] {{number}}
              span.state-cn.pull-right(:class="state") {{stateLabel}}

        .row.table-grid
          .holder-cn
              p {{oClient.name}}
              p #[translate Cod]. {{oClient.external_id}}
              p &nbsp;
          .holder-cn
              p {{center.name}}
              p {{center.address}}
              p ({{center.postal_code}}, {{center.locality}})
          .holder-cn
              p
                strong #[translate Fecha de envío]:
                span {{fecha | moment("DD-MM-YYYY")}}
              p
                strong #[translate Total]:
                span {{totalEdit | format-money}} {{moneda}}
              p &nbsp;

      .container.table-2
        .row.table-head
          div.col-sm-4 {{numItems}} #[translate productos]
          .col-sm-3 &nbsp;
          .col-sm-2.text-right #[translate Precio Unidad]
          .col-sm-2.text-right #[translate Cantidad]
          .col-sm-1.text-right #[translate total]
        .table-grid
          bk-item(v-for="item in aProduct" :editQuantity="user.can_validate_orders && !validated" :key="item.id" :entries.sync="item" :billable="isFacturable")

      .box-3
        .container
          .row
            .col-sm-8.obser-cn
              p(v-if="details")
                strong #[translate Notas]:
                small {{details}}
            .col-sm-4
              ul
                li {{numItems}} #[translate Productos]: #[small {{baseEdit | format-money}} {{moneda}}]
                li #[translate IVA]: #[small {{taxEdit | format-money}} {{moneda}}]
                li #[translate TOTAL] #[small {{totalEdit | format-money}} {{moneda}}]

      p.hidden
        button(data-toggle="modal" data-target="#modal-cart-common" class="btn-modal" ref="showModal")
      bk-modal(ref="modalCartCommon" id="modal-cart-common" :title="modal.title" :content="modal.content" :footer="modal.footer")

      .box-4
        .container
          .row
            .col-sm-8.text-right.pull-right
              p(v-if="user.can_validate_orders && type !== 'validados'")
                button.btn.btn-cancel(@click="anular()" :class="{'btn-send': enviando}")
                  span(v-if="!enviando") #[translate Anular]
                  span(v-if="enviando") #[translate Anulando]
                button.btn.btn-action(@click="validar()" :class="{'btn-send': enviando}")
                  span(v-if="!enviando") #[translate Validar]
                  span(v-if="enviando") #[translate Validando]
              p(v-if="type == 'validados'")
                button.btn.btn-cancel(@click="goBack()") #[translate Volver]
              p &nbsp;
</template>
<script>
import BkItem from '@/components/order/Item-single.vue'
import BkModal from '@/components/common/Modal.vue'

import SrvValidarPedidos from '@/services/validar-pedidos'

export default {
  name: 'PedidosValidarSingle',
  props: ['id', 'type'],
  components: { BkItem, BkModal },
  data () {
    return {
      number: null,
      fecha: null,
      oClient: null,
      center: null,
      state: null,
      state_values: null,
      base: null,
      tax: null,
      total: null,
      moneda: null,
      details: null, // descripción
      numItems: null,
      billable_center: null, // Si es facturable el centro.
      messageError: null,
      messageOk: null,
      aProduct: [],
      validated: false,
      enviando: false,
      modal: {
        // show: false,
        title: '',
        content: '',
        footer: ''
      },
    }
  },
  created () {
    this.getPedido()
    // console.log(`type: ${this.type} ,  user`, this.user)
  },
  computed: {
    baseEdit () {
      let base = 0
      this.aProduct.forEach((e) => {
        base += Number(e.base)
      })
      return base
    },
    taxEdit () {
      return this.baseEdit * 0.21
    },
    totalEdit () {
      return this.baseEdit + this.taxEdit
    },
    stateLabel () {
      let result = '-'
      if (this.state_values) {
        this.state_values.map(item => {
          if (item.code === this.state) {
            result = item.value
          }
        })
      }
      return result
    },
    isFacturable () {
      return this.billable_center
    },
    client () {
      return this.$store.getters.client
    },
    user () {
      return this.$store.getters.user
    },
    isTypeApp () {
      // console.log(`--- typeApp: ${this.$config.type}`)
      return this.$config.type
    }
  },
  methods: {
    showModalMsg (msg) {
      const aceptar = this.$gettext('Aceptar')
      this.modal.content = `<p style="text-align:center;padding-top:20px;">${msg}</p>
                            <p style="text-align:center;padding:20px 0 10px;"><button type="button" data-dismiss="modal" class="btn btn-action">${aceptar}</button></p>`
      // En el HTML hay un botón con el atributo ref="showModal" y de esta forma le hacemos click para mostrar la modal.
      this.$refs.showModal.click()
    },
    getPedido () {
      // console.log('id: ' + this.id)
      SrvValidarPedidos.getPedido(this.id, this.type)
        .then(res => {
          if (res.status === 200) {
            const data = res.data
            // console.log(`Pedido single: `, data)
            this.number = data.number
            this.fecha = data.delivery_datetime
            this.oClient = data.client
            this.center = data.center
            this.state = data.state
            this.state_values = data.state_values
            this.base = data.base
            this.tax = data.tax_total
            this.total = data.total
            this.moneda = data.currency_symbol
            this.aProduct = data.entries
            this.numItems = this.aProduct.length
            this.details = data.details
            this.billable_center = data.billable_center
            this.validated = data.validated
            // console.log(`number `, res)
          } else {
            this.messageError = this.$gettext('Se ha producido un error. Intentelo más tarde.')
          }
        }, () => {
          // console.log('----->' + error)
          this.messageError = this.$gettext('Se ha producido un error. Intentelo más tarde.')
        })
    },
    anular () {
      if (!this.enviando) {
        this.enviando = true
        SrvValidarPedidos.validarAnular(this.id, 'True')
          .then(res => {
            if (res.status === 200) {
              // console.log(`Anular: `, res.data)
              this.messageError = this.$gettext('Pedido anulado.')
            } else {
              this.messageError = this.$gettext('Se ha producido un error. Intentelo más tarde.')
            }
            // actualizamos el valor de los pedidos pendientes.
            this.$store.dispatch('updateValidableOrders')
            this.enviando = false
          }, () => {
            // console.log('----->' + error)
            this.messageError = this.$gettext('Se ha producido un error. Intentelo más tarde.')
            this.enviando = false
          })
      }
    },
    validar () {
      if (!this.enviando) {
        this.enviando = true
        if (this.baseEdit < this.center.min_order) {
          const msg = this.$gettext('<strong>PEDIDO MÍNIMO</strong><br />Recuerda que el importe mínimo para poder realizar tu pedido es de ') + this.$options.filters.formatMoney(this.center.min_order) + ' € ' + this.$gettext('sin IVA')
          this.showModalMsg(msg)
          this.enviando = false
          return false
        }
        let entriesFinish = []
        this.aProduct.forEach((p) => {
          let pNew = {
            external_id: p.external_id,
            order: p.order,
            quantity: p.quantity,
            price: p.price,
            discount: p.discount,
            base: Number(p.base).toFixed(2),
            billable: p.billable,
            product: p.product.id,
            aditional_measurement_unit: p.aditional_measurement_unit ? p.aditional_measurement_unit : null}
          entriesFinish.push(pNew)
        })
        SrvValidarPedidos.validarAnular(this.id, 'false', entriesFinish)
          .then(res => {
            if (res.status === 200) {
              // console.log(`Anular: `, res.data)
              this.messageOk = this.$gettext('Pedido validado.')
            } else {
              this.messageError = this.$gettext('Se ha producido un error. Intentelo más tarde.')
            }
            // actualizamos el valor de los pedidos pendientes.
            this.$store.dispatch('updateValidableOrders')
            this.enviando = false
          }, (error) => {
            // console.log('----->' + error)
            if (error.data.code === '100') {
              this.messageError = this.$gettext('El pedido pasa a estar pendiente de validación.')
            } else if (error.data.code === '102') {
              this.messageError = error.data.message
            } else {
              this.messageError = this.$gettext('Se ha producido un error. Intentelo más tarde.')
            }
            window.scrollTo(0, 0)
            this.enviando = false
          })
      }
    },
    goBack () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.box-search{
  padding: 14px 0;
  background-color: #EFEFEF;
}

.alert{
  margin-top: 40px;
  &.alert-success{
    background-color: #dff0d8;
    color: #3c763d;
    border:1px solid #d6e9c6;
  }
}

.state-cn{
  color: $orange;
  &.SERVIDO, &.S{
    color: $green;
  }
}

.box-1{
  padding: 26px 0 20px;
  font-size: 16px;
  small{
    font-size: 16px;
  }

  a{
    color: $blue-light;
  }
}

.table-1{
  .table-head{
    display: flex;
    justify-content: space-between;
    margin: 6px -15px 18px;

    .holder-cn{
      width: 32%;

      &:nth-child(3){
        h3 {
          font-weight: $medium;
        }
      }
    }

    h3{
      border-bottom: 1px solid #1C2C40;
      font-size: 14px;
      font-weight: $regular;
      padding-bottom: 6px;
    }

    p{
      margin: 0;
    }
  }

  .table-grid{
    display: flex;
    justify-content: space-between;
    margin: 6px -15px 18px;
    font-size: 14px;
    color:#4D4F5C;

    .holder-cn{
      width: 32%;
      padding: 20px 18px;
      background-color: #F1F4F7;
    }

    strong{
      min-width: 130px;
      display: inline-block;
      font-weight: $regular;
    }
  }
}

.table-2{
  .table-head{
    margin: 6px 0;
    & > *{
      padding-bottom: 6px;
      border-bottom: 1px solid #979797;
      font-size: 14px;

      &:first-child{
        font-weight: $medium;
      }
    }

    p{
      margin: 0;
    }
  }
}

.box-3{
  margin:24px 0 30px;

  .row{
    border-bottom: 1px solid #1C2C40;
    padding-bottom:16px;
  }

  ul{
    padding-left: 0;
    list-style: none;
  }

  li{
    color: #5b5d5e;
    font-size: 14px;
    margin-bottom: 14px;

    small{
      font-size: 14px;
      float: right;
    }

    &:last-child{
      font-size: 14px;

      small{
        font-size: 16px;
        font-weight: $medium;
      }
    }
  }

  .obser-cn{
    strong{
      font-weight: $regular;
      color: #494f58;
      font-size: 14px;
      vertical-align: top;
      margin-right: 10px;
    }

    small{
      display: inline-block;
      font-size: 14px;
      width:85%;
      height: 80px;
      overflow-wrap: break-word;
    }
  }
}

.box-4{
  p{
    font-size: 18px;
    color: #494f58;
  }

  .btn{
    font-size: 16px;
    font-weight: $regular;
    margin-left: 20px;
  }
}
</style>
